var escape = require("../../../../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".without_good[data-v-0adc36e1]:before,.without_warn[data-v-0adc36e1]:before{width:50px;min-width:50px;display:block;position:absolute;left:0}.without[data-v-0adc36e1]{margin-bottom:14px;font-family:Open Sans,sans-serif;font-weight:300;font-size:16px;line-height:1.4}@media screen and (min-width:360px){.without[data-v-0adc36e1]{font-size:18px}}.without_good[data-v-0adc36e1]{margin-bottom:30px}.without_good[data-v-0adc36e1],.without_warn[data-v-0adc36e1]{padding-left:65px}.without_good[data-v-0adc36e1]:before{height:50px;top:-12px;content:url(" + escape(require("./images/icon_good.svg")) + ")}.without_warn[data-v-0adc36e1]:before{height:40px;top:5px;content:url(" + escape(require("./images/icon_warn.svg")) + ")}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0adc36e1","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/profile/views/certificate/components/withoutcert/WithoutCert.vue
// module id = e52d14333d15a8c3cefd
// module chunks = 9